import React from 'react';
export const isHandoff = item => ['human_handoff','flow_handoff_reply'].includes(item?.decision);
export function traceNode(item) {
 if (!item) return null;
 if (item.step === 'objection') return 'objection:'+(item.context?.last_objection || item.intent);
 if (item.step === 'reception') return item.intent === 'safety_handoff' ? 'handoff' : 'reception:'+(item.intent === 'unknown' ? 'fallback' : item.intent);
 if (item.step === 'custom_question') return item.context?._pending_question?.id;
 return item.step;
}
export function nodeStatus(trace, id) {
 if (!trace.length) return '';
 const last=trace[trace.length-1];
 const current=isHandoff(last)?'handoff':last.decision==='flow_completed_reply'?'completed':traceNode(last);
 if (current===id) return 'current';
 return trace.some(item=>traceNode(item)===id)?'visited':'unvisited';
}
export default function ClinicalFlowTrace({trace=[],id}) {
 const status=nodeStatus(trace,id);
 return status ? <span className={'clinical-trace-badge '+status}>{status==='current'?'● Etapa atual':status==='visited'?'✓ Percorrida':'○ Não visitada'}</span> : null;
}
